import { defineComponent, ref } from "vue"
import { ActionSheet } from "vant"

export default defineComponent({
  name: "ActionSheetModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  defineEmits: ["close"],
  setup(props, { expose, emit }) {
    const visible = ref(props.visible) // 模态框是否显示
    const defaultConfig = {}
    const actionConfig = ref({ ...defaultConfig })
    expose({
      show: (config) => {
        actionConfig.value = { ...defaultConfig, ...config }
        visible.value = true
      }
    })

    const close = () => {
      emit("close")
    }

    return () => {
      return (
        <ActionSheet
          vModel:show={visible.value}
          {...actionConfig.value}
          onClose={close}
        ></ActionSheet>
      )
    }
  }
})
